import { useLocation, useParams } from "react-router-dom";
import { useEffect } from "react";
import httpClient from "../../HTTPService";
import { ToastContainer, toast } from 'react-toastify';
import { useState } from "react";
import { useNavigate } from "react-router-dom";
const UserEdit = () => {
    const navigate = useNavigate()
    const [editUser, setEditUser] = useState({
        id: '',
        address: '',
        phone: '',
        password: '',
        first_name: '',
        last_name: ''
    });
    const [UserName, setUserName] = useState('');
    const [isSubmitting, setisSubmitting] = useState(false)
    const location = useLocation()
    const queryParams = new URLSearchParams(location.search); // Parse query string
    const id = queryParams.get('id');

    // useEffect(() => {
    //     let getLocal = localStorage.getItem('editUsers')
    //     let editUsers = JSON.parse(getLocal)
    //     setEditUser((prev) => {
    //         return {
    //             ...prev,
    //             name: editUsers?.name,
    //             phone: editUsers?.phone,
    //             address: editUsers?.address ?? editUsers?.address,
    //             id: editUsers?.id
    //         }
    //     });
    //     // setUserName(editUsers?.name)
    // }, []);

    useEffect(() => {
        userDetails()
    }, [])

    const userDetails = async () => {

        try {
            const result = await httpClient.post('/admin/users/view', { id: id }, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });
            console.log(result.data.status);

            if (result.data.status == true) {
                console.log(result?.data, 'phnknds')
                setEditUser((prev) => {
                    return {
                        ...prev,
                        first_name: result?.data?.data?.first_name,
                        last_name: result?.data?.data?.last_name,
                        name: result?.data?.data?.full_name,
                        phone: result?.data?.data?.phone,
                        address: result?.data?.data?.address,
                        password: '',
                        id: id
                    }
                })
                // setTimeout(() => {
                //     // navigate('/alluser')
                // }, 1000)

            }
            if (result.data.status == false) {
                // toast.error(result.data.message)
            }
        } catch (error) {
            // toast.error(error.message)
        } finally {
            // setisSubmitting(false)
        }
    }

    // Edit Name
    const userEdit = async () => {
        if (isSubmitting) return;
        setisSubmitting(true)
        try {
            const result = await httpClient.post('/admin/users/edit', editUser, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });
            console.log(result.data.status);

            if (result.data.status == true) {
                // setTimeout(() => {
                //     // navigate('/alluser')
                // }, 1000)
                toast.success("User Update Successfully!")

            }
            if (result.data.status == false) {
                toast.error(result.data.message)
            }
        } catch (error) {
            toast.error(error.message)
        } finally {
            setisSubmitting(false)
        }
    }



    return (
        <div className="userEdit">
            <ToastContainer
                autoClose={1000}
            />
            <div className="card">
                <div className="row">
                    <div className="col-md-4">
                        <div className="formGroup">
                            <label>First Name</label>
                            <input
                                type="text"
                                name="first_name"
                                placeholder="first_name"
                                onChange={(e) => {
                                    setEditUser((prev) => {
                                        return {
                                            ...prev,
                                            first_name: e.target.value
                                        }
                                    })
                                }} value={editUser?.first_name} // Controlled input
                                required
                            />


                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="formGroup">
                            <label>Last Name</label>
                            <input
                                type="text"
                                name="last_name"
                                placeholder="last_name"
                                onChange={(e) => {
                                    setEditUser((prev) => {
                                        return {
                                            ...prev,
                                            last_name: e.target.value
                                        }
                                    })
                                }} value={editUser?.last_name} // Controlled input
                                required
                            />


                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="formGroup">
                            <label>Address</label>
                            <input
                                onChange={(e) => {
                                    setEditUser((prev) => {
                                        return {
                                            ...prev,
                                            address: e.target.value
                                        }
                                    })
                                }}
                                type="text" value={editUser?.address ? editUser?.address : "Address"} />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="formGroup">
                            <label>Phone Number</label>
                            <input type="text" value={editUser?.phone} readOnly />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="formGroup">
                            <label>Password</label>
                            <input type="text"
                                onChange={(e) => {
                                    setEditUser((prev) => {
                                        return {
                                            ...prev,
                                            password: e.target.value
                                        }
                                    })
                                }}
                                value={editUser?.password} placeholder="Password" />
                        </div>
                    </div>

                </div>
                <div className="row">
                    <div className="col-md-4">
                        <div className='btnFlx'>
                            <button type='button' className='addBtn' onClick={() => { navigate('/alluser'); localStorage.removeItem('editUsers') }}>Cancel</button>
                            <button type='button' className='addBtn' onClick={userEdit} disabled={isSubmitting}>Update</button>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}
export default UserEdit;